import DashboardRoutes from '../views/dashboard/dashboard.routes'
import LoginRoutes from '../views/login/login.routes'
import VideoRoutes from '../views/video/video.routes'
import ProjectsRoutes from '../views/projects/projects.routes'
import ProjectRoutes from '../views/detection/project.routes'
import ProjectDetailsRoutes from '../views/frame-view/project-details.routes'
import ProjectGalleryRoutes from '../views/video-cutting/project-gallery.routes'
import SearchRoutes from '../views/search/search.routes'
import LogsRoutes from '../views/processLogs/processLogs.routes.js'
import PersonsRoutes from '../views/persons/persons.routes.js'
// import FilesRoutes from '../views/files/files.routes'

export default () => {
  DashboardRoutes()
  LoginRoutes()
  VideoRoutes()
  ProjectsRoutes()
  ProjectRoutes()
  ProjectDetailsRoutes()
  ProjectGalleryRoutes()
  SearchRoutes()
  LogsRoutes()
  PersonsRoutes()
  // FilesRoutes()
}
